import React, { useState, useRef, useEffect } from "react";
import { Container, Typography, Grid, Button } from "@mui/material";
import EscolaCampos from "./FormsEscola";
import axios from "axios";

import { api } from "@api/api";
import TransicaoPagina from "../../../componentes/comuns/TransicaoPagina";

const RegistroEscola = () => {
  const [formData, setFormData] = useState({
    nome: "",
    rua: "",
    bairro: "",
    municipio: "",
    cep: "",
    numero: "",
    contato: "",
    email: "",
    modalidade: "",
    anosSelecionados: [],
  });

  const [file, setFile] = useState(null);
  const [escolaSelecionada, setEscolaSelecionada] = useState("");
  const [novoNomeEscola, setNovoNomeEscola] = useState("");

  const [mantenedoraRegistrada, setMantenedoraRegistrada] = useState(null);
  const [mantenedoraAtiva, setMantenedoraAtiva] = useState(null);
  const [carregando, setCarregando] = useState(true);

  const escolaCamposRef = useRef();

  useEffect(() => {
    const checkMantenedoraStatus = async () => {
      try {
        const response = await axios.get(api.verify(), {
          withCredentials: true,
        });

        console.log("Resposta da API:", response.data);

        const { isRegistered, ativo } = response.data;

        setMantenedoraRegistrada(isRegistered);
        setMantenedoraAtiva(ativo);
      } catch (error) {
        console.error("Erro ao verificar mantenedora:", error);
      } finally {
        setCarregando(false);
      }
    };

    checkMantenedoraStatus();
  }, []);

  const handleDataChange = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
  };

  const handleFileChange = (selectedFile) => {
    setFile(selectedFile);
  };

  const limparCampos = () => {
    setFormData({
      nome: "",
      rua: "",
      bairro: "",
      municipio: "",
      cep: "",
      numero: "",
      contato: "",
      email: "",
      modalidade: "",
      anosSelecionados: [],
    });

    setFile(null);
    setEscolaSelecionada("");
    setNovoNomeEscola("");

    if (escolaCamposRef.current) {
      escolaCamposRef.current.limparCamposInternos();
    }
  };

  const handleSubmit = async () => {
    try {
      if (!formData.nome || !formData.modalidade) {
        alert("Nome da escola e modalidade são obrigatórios!");
        return;
      }

      if (!file) {
        alert("O documento é obrigatório!");
        return;
      }

      const formDataToSend = new FormData();

      Object.entries(formData).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((item) => formDataToSend.append(`${key}[]`, item));
        } else {
          formDataToSend.append(key, value);
        }
      });

      formDataToSend.append("documento", file);

      const response = await axios.post(api.registerSchool(), formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        withCredentials: true,
      });

      alert("Escola cadastrada com sucesso!");
      limparCampos();
    } catch (error) {
      console.error("Erro detalhado:", error.response?.data || error.message);

      alert(`Erro: ${error.response?.data?.message || error.message}`);
    }
  };

  if (carregando) {
    return (
      <Typography variant="h6" align="center" color="textSecondary">
        Carregando informações...
      </Typography>
    );
  }

  if (!mantenedoraRegistrada) {
    return (
      <TransicaoPagina variante="navegacao">
        <Typography variant="h6" align="center" color="error">
          Nenhuma mantenedora registrada. Por favor, registre uma antes de
          cadastrar uma escola.
        </Typography>
      </TransicaoPagina>
    );
  }

  if (!mantenedoraAtiva) {
    return (
      <TransicaoPagina variante="navegacao">
        <Typography variant="h6" align="center" color="error">
          Por favor, espere o deferimento do cadastro da mantenedora antes de
          cadastrar uma escola.
        </Typography>
      </TransicaoPagina>
    );
  }

  return (
    <TransicaoPagina variante="navegacao">
      <div>
        <Container maxWidth={false} disableGutters sx={{ marginTop: 4 }}>
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              fontWeight: "bold",
              color: "#1976d2",
              textAlign: "center",
            }}
          >
            Registro Escolar
          </Typography>

          <EscolaCampos
            ref={escolaCamposRef}
            onDataChange={handleDataChange}
            onFileChange={handleFileChange}
            escolaSelecionada={escolaSelecionada}
            setEscolaSelecionada={setEscolaSelecionada}
            novoNomeEscola={novoNomeEscola}
            setNovoNomeEscola={setNovoNomeEscola}
          />

          <Grid container justifyContent="flex-end" sx={{ marginTop: 3 }}>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                sx={{
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#1565c0" },
                }}
              >
                Enviar
              </Button>
            </Grid>
          </Grid>
        </Container>
      </div>
    </TransicaoPagina>
  );
};

export default RegistroEscola;
